module.exports = {"320411002":"三井街道","320411003":"龙虎塘街道","320411004":"春江街道","320411005":"魏村街道","320411006":"新桥街道","320411101":"孟河镇","320411103":"薛家镇","320411104":"罗溪镇","320411105":"西夏墅镇","320411122":"奔牛镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320411.json
// module id = 959
// module chunks = 0